import loader from './components/loader.js';
import flickity from './components/flickity.js';
import flickityRef from './components/referenzSlider.js';
import mixitup from './components/mixitup.js';
import './components/jarallax.js';

import AOS from 'aos';
AOS.init({ once: true });